import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HouseIcon from "@mui/icons-material/House";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const ContactHeader = () => {
  return (
    <Box padding={"1%"}>
      <Box
        width={"90%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box display={"flex"} alignItems={"center"}>
          <HouseIcon
            sx={{
              color: "#00AEFF",
              width: 18,
              height: 18,
            }}
          />{" "}
          <Typography variant="body2" color={"#fff"} textAlign={"left"}>
            <Typography component={"span"} fontWeight={700} variant="body2">
              Office{" "}
            </Typography>
            20, Soetan Street, Asero Estate, Abeokuta
          </Typography>
        </Box>
        <Box display={"flex"} alignItems={"center"}>
          <EmailIcon
            sx={{
              color: "#00AEFF",
              width: 18,
              height: 18,
            }}
          />{" "}
          <Typography variant="body2" color={"#fff"} textAlign={"left"}>
            <Typography component={"span"} fontWeight={700} variant="body2">
              Email{" "}
            </Typography>
            info@aquatichubafrique.com
          </Typography>
        </Box>
        <Box display={"flex"} alignItems={"center"}>
          <PhoneIcon
            sx={{
              color: "#00AEFF",
              width: 18,
              height: 18,
            }}
          />{" "}
          <Typography variant="body2" color={"#fff"} textAlign={"left"}>
            <Typography component={"span"} fontWeight={700} variant="body2">
              Phone{" "}
            </Typography>
            +234 703 424 8150
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactHeader;
